import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { CustomerProductService } from "../services/customerProduct.service";
import { AuthService } from "../services/auth.service";

@Component({
  selector: "app-substitute-approval",
  templateUrl: "./substitute-approval.component.html",
  styleUrls: ["./substitute-approval.component.sass"],
})
export class SubstituteApprovalComponent implements OnInit {
  @ViewChild("moreInfoModal", { static: true })
  moreInfoModal!: TemplateRef<unknown>;

  isLoading = true;
  isSubmittingMoreInfo = false;
  moreInfo = "";
  moreInfoError = "";

  title = "Processing Your Request";
  message = "Please wait while we process your substitute approval request.";

  private id: string | null = null;
  private rule: string | null = null;
  private moreInfoModalRef?: NgbModalRef;

  constructor(
    private route: ActivatedRoute,
    private customerProductService: CustomerProductService,
    private router: Router,
    private authService: AuthService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get("id");
    const type = this.route.snapshot.queryParamMap.get("type");
    this.rule = this.route.snapshot.queryParamMap.get("rule");

    if (!this.authService.isAuthenticated()) {
      this.isLoading = false;
      this.title = "Please Login";
      this.message = "You are not logged in.";
    } else if (!this.id || !type) {
      this.isLoading = false;
      this.title = "Invalid Request";
      this.message =
        "The approval link is invalid or missing required information.";
    } else if (type === "more-info") {
      this.openMoreInfoModal();
    } else {
      this.processAction(type);
    }
  }

  submitMoreInfo(): void {
    const info = this.moreInfo.trim();

    if (!info) {
      this.moreInfoError = "Please enter the information you need.";
      return;
    }

    this.moreInfoError = "";
    this.processAction("more-info", info);
  }

  cancelMoreInfo(): void {
    this.moreInfoModalRef?.dismiss();
    this.isLoading = false;
    this.title = "Request Not Submitted";
    this.message = "No request for more information was sent.";
  }

  private openMoreInfoModal(): void {
    this.isLoading = false;
    this.title = "Request More Information";
    this.message = "Add the information needed to review this substitute request.";
    this.moreInfoModalRef = this.modalService.open(this.moreInfoModal, {
      size: 'sm',
      centered: true,
      backdrop: "static",
      keyboard: false,
      windowClass: "deleteModal",
    });
  }

  private processAction(type: string, info?: string): void {
    if (!this.id || this.isSubmittingMoreInfo) {
      return;
    }

    this.isLoading = true;
    this.isSubmittingMoreInfo = type === "more-info";

    this.customerProductService
      .approveSubstituteAction(this.id, type, this.rule || undefined, info)
      .subscribe({
        next: () => {
          this.moreInfoModalRef?.close();
          this.isLoading = false;
          this.isSubmittingMoreInfo = false;
          this.title = "Request Processed Successfully";
          this.message =
            "Your substitute approval request has been completed. Redirecting...";

          setTimeout(() => {
            this.router.navigate(["/home"]);
          }, 2000);
        },
        error: () => {
          this.isLoading = false;
          this.isSubmittingMoreInfo = false;
          this.title = "Unable to Process Request";
          this.message =
            "An error occurred while processing your substitute approval request. Please try again later.";

          if (type === "more-info") {
            this.moreInfoError =
              "Unable to send your request. Please try again.";
          }
        },
      });
  }
}
